const {
  assoc,
  head,
  mapObj,
  values,
} = require('ramda')
const { Stream, reduceMerge } = require('refunc')

function streamFactory (spec) {
  const tuples = mapObj((val) => [ Stream(), val ], spec)
  const base = mapObj(head, tuples)
  const main = reduceMerge([], values(tuples))
  return assoc('main', main, base)
}

module.exports = streamFactory
